// ProductSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import './ProductSection.css';

const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
        stars.push(<span key={`star-${i}`} className="star">★</span>);
    }

    if (halfStar) {
        stars.push(<span key="half-star" className="star half">★</span>);
    }

    while (stars.length < 5) {
        stars.push(<span key={`empty-star-${stars.length}`} className="star empty">★</span>);
    }

    return stars;
};

export const products = [
    {
        id: 1,
        sectionImage: '/product10.png',
        detailImages: ['/product11.jpg','/product12.png', '/product13.jpg', '/product14.jpg', '/product15.jpg'],
        name: 'Neteros MB25',
        price: 248.00,
        description: "Un complément conçu pour booster votre métabolisme et optimiser votre bien-être au quotidien.",
        characteristics: [
            { icon: '/energy.png', text: 'Augmentation d\'énergie' },
            { icon: '/combustion.png', text: 'Favorise la combustion des graisses' },
            { icon: '/strong.png', text: 'Élimination de l\'excès d\'eau' },
            { icon: '/vessel.png', text: 'Amélioration de la circulation' },
            { icon: '/intestines.png', text: 'Digestion optimisée' }
        ],
        descriptionTitle: "Augmentez Votre Métabolisme de 25%",
        descriptionList: [
            { number: 1, title: "Caféine et Thé Vert", text: "Augmentent votre énergie, favorisent la combustion des graisses et éliminent votre excès d'eau." },
            { number: 2, title: "Extrait d'Orange Amère", text: "Accélère votre métabolisme pour des résultats rapides." },
            { number: 3, title: "Extrait de Poivre de Cayenne", text: "Stimule votre circulation et améliore votre 'pump' à l'entraînement et favorise la combustion des graisses." },
            { number: 4, title: "Extrait de Ginseng", text: "Stimule votre énergie et améliore votre endurance." },
            { number: 5, title: "Extrait de Graines d'Ananas", text: "Favorise votre digestion des protéines et optimise votre circulation." },
        ],
        descriptionImage: "/fruits_num.png",
        reviews: [
            { id: 1, rating: 5, text: "Je remarque que mon corps est plus affiné et plus tonique. J’ai aussi moins de fringales, ce qui m’aide à mieux manger !", author: "Lina S." },
            { id: 2, rating: 5, text: "Fini les baisses d’énergie en pleine journée ! Je me sens plus en forme et plus motivée pour mes entraînements.", author: "Imane R." },
            { id: 3, rating: 4, text: "J’ai plus d’endurance pendant mes séances de sport et je récupère plus vite après l’effort.", author: "Adam K." },
            { id: 4, rating: 5, text: "Je digère beaucoup mieux et je ressens moins de ballonnements. Mon bien-être général s’est nettement amélioré.", author: "Sofia M." },
            { id: 5, rating: 4, text: "L’ajout de l’eBook est un vrai plus ! Il m’aide à mieux organiser mes repas et à garder un bon équilibre pendant mon régime.", author: "Khadija B." },
            { id: 6, rating: 5, text: "Je me sens plus concentré et plus productif au quotidien. Mon niveau d’énergie est stable du matin au soir.", author: "Samir C." },
            { id: 7, rating: 4, text: "Je vois une belle différence sur mon corps, surtout au niveau du ventre. Ce produit m’aide à mieux gérer mon appétit.", author: "Inès D." },
            { id: 8, rating: 5, text: "Mon corps est plus dessiné et je ressens moins de rétention d’eau. Je suis vraiment satisfait !", author: "Walid A." },
            { id: 9, rating: 5, text: "L’eBook est super utile pour structurer mes repas et éviter les erreurs alimentaires pendant mon programme de perte de poids.", author: "Nassim B." },
        ],
        reviewCount: 171,
        servings: '90 capsules',
        promoMessage: "FREE EBOOK",
        isPack: false, // Single product
    },
    {
        id: 2,
        sectionImage: '/product20.png',
        detailImages: ['/product11.jpg','/product12.png', '/product24.jpg', '/product23.jpg', '/product14.jpg'],
        name: 'Pack Neteros MB25 X2',
        price: 459.00,
        originalPrice: '496.00 dh',
        description: "Un complément conçu pour booster votre métabolisme et optimiser votre bien-être au quotidien.",
        characteristics: [
            { icon: '/energy.png', text: 'Augmentation d\'énergie' },
            { icon: '/combustion.png', text: 'Favorise la combustion des graisses' },
            { icon: '/strong.png', text: 'Élimination de l\'excès d\'eau' },
            { icon: '/vessel.png', text: 'Amélioration de la circulation' },
            { icon: '/intestines.png', text: 'Digestion optimisée' }
        ],
        descriptionTitle: "Augmentez Votre Métabolisme de 25%",
        descriptionList: [
            { number: 1, title: "Caféine et Thé Vert", text: "Augmentent votre énergie, favorisent la combustion des graisses et éliminent votre excès d'eau." },
            { number: 2, title: "Extrait d'Orange Amère", text: "Accélère votre métabolisme pour des résultats rapides." },
            { number: 3, title: "Extrait de Poivre de Cayenne", text: "Stimule votre circulation et améliore votre 'pump' à l'entraînement et favorise la combustion des graisses." },
            { number: 4, title: "Extrait de Ginseng", text: "Stimule votre énergie et améliore votre endurance." },
            { number: 5, title: "Extrait de Graines d'Ananas", text: "Favorise votre digestion des protéines et optimise votre circulation." },
        ],
        descriptionImage: "/fruits_num.png",
        reviews: [
            { id: 1, rating: 4, text: "L’ajout de l’eBook est un vrai plus ! Il m’aide à mieux organiser mes repas et à garder un bon équilibre pendant mon régime.", author: "Khadija B." },
            { id: 2, rating: 5, text: "Je me sens plus concentré et plus productif au quotidien. Mon niveau d’énergie est stable du matin au soir.", author: "Samir C." },
            { id: 3, rating: 5, text: "Je digère beaucoup mieux et je ressens moins de ballonnements. Mon bien-être général s’est nettement amélioré.", author: "Sofia M." },
            { id: 4, rating: 5, text: "Fini les baisses d’énergie en pleine journée ! Je me sens plus en forme et plus motivée pour mes entraînements.", author: "Imane R." },
            { id: 5, rating: 4, text: "J’ai plus d’endurance pendant mes séances de sport et je récupère plus vite après l’effort.", author: "Adam K." },
            { id: 6, rating: 5, text: "Mon corps est plus dessiné et je ressens moins de rétention d’eau. Je suis vraiment satisfait !", author: "Walid A." },
            { id: 7, rating: 5, text: "Je remarque que mon corps est plus affiné et plus tonique. J’ai aussi moins de fringales, ce qui m’aide à mieux manger !", author: "Lina S." },
            { id: 8, rating: 4, text: "Je vois une belle différence sur mon corps, surtout au niveau du ventre. Ce produit m’aide à mieux gérer mon appétit.", author: "Inès D." },
            { id: 9, rating: 5, text: "L’eBook est super utile pour structurer mes repas et éviter les erreurs alimentaires pendant mon programme de perte de poids.", author: "Nassim B." },
        ],
        reviewCount: 11,
        servings: '90 capsules',
        promoMessage: "FREE EBOOK + CARTE COUPON",
        isPack: true, // Product pack
    },
    {
        id: 3,
        sectionImage: '/product31.png',
        detailImages: ['/product31.jpg','/32.png', '/product33.jpeg', '/product34.jpeg', '/product35.jpg'],
        name: 'Collagène Marin + Vitamine C',
        price: 264.00,
        description: "Prenez 3 capsules par jour avec de l'eau.",
        characteristics: [
            { icon: '/p26.png', text: 'Peau radieuse & anti-âge' },
            { icon: '/p27.png', text: 'Renforcement des articulations & des os' },
            { icon: '/p28.png', text: 'Amélioration de l\'élasticité de la peau' },
            { icon: '/p29.png', text: 'Soutien du système immunitaire' },
            { icon: '/p30.png', text: 'Santé digestive & équilibre intestinal' },
            { icon: '/p31.png', text: 'Ongles plus forts et croissance optimisée' }
        ],
        descriptionTitle: "Soutenez votre corps, de la peau jusqu’aux intestins ",
        descriptionList: [
            { number: 1, title: "Collagène Marin", text: "Favorise l'élasticité de la peau, la santé  des articulations , des ongles et des articulations..." },
            { number: 2, title: "Vitamine C", text: "Booste l’immunité, stimule le collagène, améliore l’absorption du fer, protège les cellules et favorise la récupération musculaire." },
        ],
        descriptionImage: "/collagen.png",
        reviews: [],
        reviewCount: 171,
        servings: '90 capsules',
        promoMessage: "FREE EBOOK",
        isPack: false, // Single product
    },
    {
        id: 4,
        sectionImage: '/product40.png',
        detailImages: ['/product31.jpg','/32.png', '/product24.jpg', '/product35.jpg'],
        name: 'Collagène Marin + Vitamine C',
        price: 491.00,
        originalPrice: '528.00 dh',
        description: "Prenez 3 capsules par jour avec de l'eau.",
        characteristics: [
            { icon: '/p26.png', text: 'Peau radieuse & anti-âge' },
            { icon: '/p27.png', text: 'Renforcement des articulations & des os' },
            { icon: '/p28.png', text: 'Amélioration de l\'élasticité de la peau' },
            { icon: '/p29.png', text: 'Soutien du système immunitaire' },
            { icon: '/p30.png', text: 'Santé digestive & équilibre intestinal' },
            { icon: '/p31.png', text: 'Ongles plus forts et croissance optimisée' }
        ],
        descriptionTitle: "Soutenez votre corps, de la peau jusqu’aux intestins ",
        descriptionList: [
            { number: 1, title: "Collagène Marin", text: "Favorise l'élasticité de la peau, la santé  des articulations , des ongles et des articulations..." },
            { number: 2, title: "Vitamine C", text: "Booste l’immunité, stimule le collagène, améliore l’absorption du fer, protège les cellules et favorise la récupération musculaire." },
        ],
        descriptionImage: "/collagen.png",
        reviews: [],
        reviewCount: 171,
        servings: '90 capsules',
        promoMessage: "FREE EBOOK + CARTE COUPON",
        isPack: true,
    },

];

const ProductSection = () => {
    return (
        <section id="produits" className="product-section">
            <h2>DES PRODUITS À FORMULATIONS UNIQUES !</h2>
            <p>Boostez votre bien-être avec des formules inspirées de la nature.</p>
            <div className="product-list">
                {products.map((product) => (
                    <Link to={`/product/${product.id}`} key={product.id} className="product-item">
                        <div className="product-image">
                            <img src={product.sectionImage || '/placeholder.png'} alt={product.name} />
                        </div>
                        <h4>{product.name}</h4>
                        <p className="price">{product.price} DH <span className="original-price">{product.originalPrice}</span></p>
                        {product.promoMessage && <p className="promo-message">{product.promoMessage}</p>}
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default ProductSection;
